module.exports = __webpack_public_path__ + "img/template-circle-4.5e786529.png";